import React, { useEffect, useState } from "react";
import { Table, ConfigProvider, Image, Button } from "antd";
import { observer } from "mobx-react-lite";
import { useAttendance } from "../../app/hooks/useAttendance";
import moment from "moment";
import { useStore } from "../../app/stores/store";

const AttendanceList = () => {
  const { attendaceStore } = useStore();
  const {
    startDate,
    endDate,
    employeeId,
    //employeeNumber,
    setIsAttendanceModalOpen,
    setAttendaceIndexObj,
    setDate,
  } = attendaceStore;

  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const currentDate = moment().format("YYYY-MM-DD");
    if (!startDate) setDate(currentDate);
    if (!endDate) setDate(currentDate);
  }, [startDate, endDate, setDate]);

  const { data, isLoading } = useAttendance({
    employeeId: employeeId ?? "",
    //employeeNumber: employeeNumber ?? "",
    startDate: startDate ?? "",
    endDate: endDate ?? "",
    sort: "date_descend",
    pageNumber: pageNumber,
    pageSize: 10,
  });

  //const currentDate = moment().format("dddd, MMMM D, YYYY");
 const formatTime = (timeString) => {
   const clean = timeString.split(".")[0].replace("Z", "");
   return moment(clean, "HH:mm:ss").format("h:mm:ss A");
 };

 const formatDate = (value) => {
   return moment(value).format("dddd, MMMM D, YYYY");
 };

 const handleImageClickWithImagePath = (rowData) => {
   setIsAttendanceModalOpen(true);
   setAttendaceIndexObj(rowData);
   //console.log("Clicked row data:", rowData);
 };

 const handleNextPage = () => {
   setPageNumber(pageNumber + 1);
 };

 const handlePreviousPage = () => {
   if (pageNumber > 1) {
     setPageNumber(pageNumber - 1);
   }
 };

 const columns = [
   {
     title: "",
     dataIndex: "timeInImagePath" || "timeOutImagePath",
     key: "timeInImagePath" || "timeOutImagePath",
     render: (text, record) => (
       // <img
       //   src={text}
       //   alt={text.name}
       //   width={80}
       //   height={80}
       //   style={{ borderRadius: 52 }}
       //   onClick={() => handleImageClickWithImagePath(record)}
       // />
       <Image
         preview={false}
         width={100}
         height={100}
         src={text}
         style={{ borderRadius: 52 }}
         onClick={() => handleImageClickWithImagePath(record)}
         fallback="data:image/png;base64,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"
       />
     ),
     align: "center",
   },
   {
     title: "Employee Number", // Changed title here
     dataIndex: "employeeNumber", // Changed dataIndex here
     key: "employeeNumber",
     align: "center",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{text}</p>,
   },
   {
     title: "Employee Name",
     dataIndex: "employeeName",
     key: "employeeName",
     align: "center",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{text}</p>,
   },
   {
     title: "Date",
     dataIndex: "dateIn",
     key: "dateIn",
     align: "center",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{formatDate(text)}</p>,
   },
   {
     title: "Time in",
     dataIndex: "timeInAt",
     key: "timeInAt",
     align: "center",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{formatTime(text)}</p>,
   },
   {
     title: "Time Out",
     key: "timeOutAt",
     dataIndex: "timeOutAt",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{text !== "00:00:00" ? <p>{formatTime(text)}</p> : <p>-------</p>}</p>,
     align: "center",
   },
   {
     title: "Location",
     key: "location",
     dataIndex: ["timeInLocation", "timeOutLocation"],
     render: (text, record) => (
       <p style={{ color: "black", fontSize: 17 }}>
         {record.timeInLocation} - {record.timeOutLocation}
       </p>
     ),
     align: "center",
   },
   {
     title: "Project",
     key: "",
     dataIndex: "",
     render: () => <p style={{ color: "black", fontSize: 17 }}></p>,
     align: "center",
   },
   {
     title: "Work Hours",
     key: "workHours",
     dataIndex: "workHours",
     render: (text) => <p style={{ color: "black", fontSize: 17 }}>{text}</p>,
     align: "center",
   },
 ];

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorBgContainer: "white",
            margin: 16,
            boxShadowSecondary:
              "0 4px 8px 0 rgba(0, 0, 0.5, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: 8,
            padding: 25,
          },
          components: {
            Table: {
              // Seed Token
              headerBg: "#FF7201",
              headerColor: "white",
              headerSplitColor: "#2C2C2C",
            },
          },
        }}
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={isLoading}
          style={{ width: "100%", marginRight: "auto", marginLeft: "0" }}
          scroll={{ x: 700 }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Button
            type="primary"
            onClick={handlePreviousPage}
            style={{ marginRight: "10px", backgroundColor: "#FF7201" }}
          >
            Previous Page
          </Button>
          <Button
            type="primary"
            onClick={handleNextPage}
            style={{ backgroundColor: "#FF7201" }}
          >
            Next Page
          </Button>
        </div>
      </ConfigProvider>
    </>
  );
};

export default observer(AttendanceList);
